"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const select_style_1 = __importDefault(require("./select.style"));
const status_1 = require("../constants/status");
const select_menu_1 = __importDefault(require("./select.menu"));
const select_button_1 = __importDefault(require("./select.button"));
class Select extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            expanded: false
        };
        this.handleToggle = () => {
            this.setState({
                expanded: !this.state.expanded
            });
        };
        this.handleCollapse = () => {
            this.setState({
                expanded: false
            });
        };
        this.handleOptionClick = e => {
            this.props.onChange(e);
            this.handleCollapse();
        };
        this.getLabel = () => {
            const selectedOption = react_1.Children.toArray(this.props.children).find(option => option.props.selected === true);
            if (!selectedOption)
                return this.props.placeholder;
            return selectedOption.props.label;
        };
        this.getOptions = () => react_1.Children.map(this.props.children, option => react_1.cloneElement(option, {
            onClick: this.handleOptionClick
        }));
        this.render = () => {
            const { classes, id, placeholder, status, disabled, onBlur, onFocus, selectRef } = this.props;
            const label = this.getLabel();
            const rootProps = {
                className: classes.root,
                ref: selectRef
            };
            const buttonProps = {
                id,
                onFocus,
                onBlur,
                onClick: this.handleToggle,
                hasValue: label !== placeholder,
                status,
                disabled,
                buttonRef: el => {
                    this.button = el;
                }
            };
            const selectMenuProps = {
                onCollapse: this.handleCollapse,
                hasValue: label !== placeholder,
                buttonElement: this.button,
                children: this.getOptions()
            };
            return (jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(select_button_1.default, Object.assign({}, buttonProps, { children: label }), void 0),
                    !disabled && this.state.expanded && (jsx_runtime_1.jsx(select_menu_1.default, Object.assign({}, selectMenuProps), void 0))] }), void 0));
        };
    }
}
exports.Select = Select;
Select.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    id: prop_types_1.default.string,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    onChange: prop_types_1.default.func,
    selectRef: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    status: prop_types_1.default.oneOf([
        status_1.STATUS_INVALID,
        status_1.STATUS_CAUTION,
        status_1.STATUS_VALID,
        status_1.STATUS_MODIFIED
    ]),
    disabled: prop_types_1.default.bool
};
Select.defaultProps = {
    id: null,
    onFocus: () => { },
    onBlur: () => { },
    onChange: () => { },
    selectRef: () => { },
    placeholder: '',
    status: null,
    disabled: false
};
exports.default = react_jss_1.default(select_style_1.default)(Select);
//# sourceMappingURL=select.js.map